/**
 * Initializes the global search functionality for desktop and mobile devices.
 * Attaches event listeners to search forms and toggles behavior based on screen type.
 */
export const globalSearch = () => {
    const searchForms = document.querySelectorAll('.page-searchform');
    const isMobileDevice = isMobile();

    /**
     * Class representing a search form component.
     */
    class SearchForm {
        /**
         * Create a SearchForm instance.
         * @param {HTMLFormElement} form - The form element to enhance with search functionality.
         */
        constructor(form) {
            /** @type {HTMLFormElement} */
            this.form = form;

            /** @type {HTMLInputElement} */
            this.input = form.querySelector('.search-input');

            /** @type {HTMLButtonElement} */
            this.btn = form.querySelector('.search-btn');

            /** @type {HTMLElement} */
            this.toggle = form.querySelector('.search-icon');

            /** @type {HTMLElement} */
            this.icon = this.toggle.querySelector('.icon');

            /** @type {boolean} */
            this.isOpen = false;

            this.addEventListeners();
        }

        /**
         * Opens the search field UI.
         */
        open() {
            this.form.classList.add('search-open');
            this.icon.classList.replace('icon-magnifier', 'icon-close');
            this.input.setAttribute('tabindex', '0');
            this.input.focus();
            this.isOpen = true;
        }

        /**
         * Closes the search field UI.
         */
        close() {
            this.form.classList.remove('search-open');
            this.icon.classList.replace('icon-close', 'icon-magnifier');
            this.input.setAttribute('tabindex', '-1');
            this.input.blur();
            this.isOpen = false;
        }

        /**
         * Attaches click and focus event listeners to the form and document.
         */
        addEventListeners() {
            this.toggle.addEventListener('click', (e) => {
                e.preventDefault();
                this.isOpen ? this.close() : this.open();
            });

            if (!isMobileDevice) {
                document.addEventListener('click', (e) => {
                    if (this.isOpen && !this.form.contains(e.target)) {
                        this.close();
                        document.querySelector('.search-xl .search-icon')?.focus();
                    }
                });
            }
        }
    }

    // Initialize search form functionality for desktop
    if (!isMobileDevice && searchForms.length > 0) {
        searchForms.forEach((form) => new SearchForm(form));
    }

    // Initialize search field behavior for mobile (using Bootstrap collapse)
    if (isMobileDevice) {
        const searchBox = document.getElementById('mobileSearch');
        if (searchBox) {
            searchBox.addEventListener('shown.bs.collapse', () => {
                document.querySelector('#globalSearchMobile')?.focus();
            });

            searchBox.addEventListener('hidden.bs.collapse', () => {
                document.querySelector('.search-xl .search-icon')?.focus();
            });
        }
    }
};